/**
 * Liquidez do imóvel: lista fechada escolhida pelo avaliador no step de Avaliação.
 *
 * O texto é enviado como está na integração com o Bari (o Salesforce mapeia 1:1 para
 * Liquidez_imovel__c), então a grafia — inclusive o acento de "Rápida" — não pode mudar.
 * O campo é só informativo: não entra em nenhum cálculo do laudo.
 */
export const LIQUIDEZ_VALORES = ['Lenta', 'Normal', 'Rápida'] as const;

export type LiquidezImovel = (typeof LIQUIDEZ_VALORES)[number];

export const LIQUIDEZ_OPTIONS = LIQUIDEZ_VALORES.map((valor) => ({ label: valor, value: valor, disabled: false }));

export const LIQUIDEZ_OBRIGATORIA_MENSAGEM = 'Selecione a liquidez do imóvel (Lenta, Normal ou Rápida)';

const normalizar = (texto: string) =>
  texto.normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();

/**
 * Converte para um valor do domínio, sem diferenciar maiúsculas nem acentos ("rapida" → "Rápida").
 * Qualquer outra coisa — vazio, texto fora da lista ou o fator numérico dos laudos antigos — vira
 * undefined, o que obriga o avaliador a escolher de novo.
 */
export function parseLiquidez(valor: unknown): LiquidezImovel | undefined {
  if (typeof valor !== 'string') return undefined;
  const alvo = normalizar(valor);
  return LIQUIDEZ_VALORES.find((opcao) => normalizar(opcao) === alvo);
}
